import * as React from "react";
import {useCallback, useState} from "react";
import {JsonEditor} from "components/core/json-editor";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import { NormalizationFactors } from "benchmarking-domain/normalization-factors";
import * as NormalizationFactorsSchema from "benchmarking-domain/schemas/normalization-factors.schema.json";

interface NormalizationFactorsFormProps {
  headerTitle: string;
  normalizationFactors?: NormalizationFactors;
  onSubmit: (data: NormalizationFactors) => Promise<void>;
}

export function NormalizationFactorsForm({headerTitle, normalizationFactors, onSubmit}: NormalizationFactorsFormProps): React.JSX.Element {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [jsonObject, setJsonObject] = useState<{}>({...normalizationFactors});

  const jsonChangeHandler = useCallback((data: any) => {
    setJsonObject(data);
  }, []);

  const submitChanges = useCallback(async () => {
    setIsSaving(true);
    try {
      await onSubmit(jsonObject as NormalizationFactors);
    } finally {
      setIsSaving(false);
    }
  }, [onSubmit, jsonObject])

  return (
    <Card sx={{overflow: "visible"}}>
      <CardHeader title={headerTitle}/>
      <Divider/>
      <CardContent>
        <JsonEditor json={normalizationFactors} schema={NormalizationFactorsSchema} onChangeJson={jsonChangeHandler} />
      </CardContent>
      <Divider/>
      <CardActions sx={{justifyContent: 'flex-end'}}>
        <Button onClick={submitChanges} variant="contained" disabled={isSaving}>Save details</Button>
      </CardActions>
    </Card>

  );
}
